import Constants from '../../constants.js';
import {backend} from '../../backend.js'

const REFRESH_INTERVAL = Constants.get('REPORT_ELAPSED_TIME_REFRESH_INTERVAL');

export default {
    namespaced: true,
    state: {
        currentReport: null,
        workingTime: null,
        timer: null,
        placesActive: null,
        placesAll: null,
    },
    getters: {
        currentReport(state) {
            return state.currentReport;
        },
        workingTimeMinutes(state) {
            return state.workingTime;
        },
        workingTimeMoment(state) {
            return moment().startOf('day').add(state.workingTime, 'minutes');
        },
    },
    actions: {
        setCurrentReport({dispatch, commit, state}, currentReport) {
            if (!state.currentReport || !currentReport || state.currentReport.id !== currentReport.id) {
                if (state.currentReport)
                    dispatch('stopTimer');
                state.currentReport = currentReport;
                commit('checkWorkingTime');
                if (currentReport)
                    dispatch('startTimer');
            }
        },
        startTimer({commit, state}) {
            state.timer = setInterval(() => {
                commit('checkWorkingTime');
            }, REFRESH_INTERVAL);
        },
        stopTimer({commit, state}) {
            clearInterval(state.timer);
        },
        places({state}, archived=false) {
            if (archived)
                return state.placesAll
                    ? state.placesAll
                    : state.placesAll = backend.getPlaces(true).then(response => response.data);
            else
                return state.placesActive
                    ? state.placesActive
                    : state.placesActive = backend.getPlaces(false).then(response => response.data);
        },
    },
    mutations: {
        checkWorkingTime(state) {
            if (state.currentReport !== null) {
                let reportStart = moment(state.currentReport.on_date).startOf('day').add(state.currentReport.from_hour, 'minutes');
                state.workingTime = moment().diff(reportStart, 'minutes');
            }
            else
                state.workingTime = null;
        },
    },
}




// WEBPACK FOOTER //
// ./app/store/modules/ia.js